import { httpClient } from '@/lib/api/client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { env } from '@/lib/config/env';
import { mockApi, type DashboardSummary } from '@/lib/api/mock/adapter';

export type { DashboardSummary };

export type DashboardRange = 'today' | '7d' | '30d' | '12m';

export interface DashboardRepository {
  summary(range?: DashboardRange): Promise<DashboardSummary>;
}

const http: DashboardRepository = {
  summary: (range = 'today') =>
    httpClient.get<DashboardSummary>(`${ENDPOINTS.dashboard.summary}?range=${range}`),
};

const mock: DashboardRepository = {
  summary: (range = 'today') => mockApi.dashboardSummary(range),
};

export const dashboardRepository: DashboardRepository = env.useMockApi ? mock : http;
